import { Component, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { CustomerService } from 'src/app/services/customer.service';

import { AssignUsersComponent } from '../assign-users/assign-users.component';
import { ListCustomerUsersComponent } from '../list-customer-users/list-customer-users.component';
@Component({
    selector: 'app-customer-users',
    templateUrl: './customer-users.component.html',
    styleUrls: ['./customer-users.component.css'],
    imports: [AssignUsersComponent, ListCustomerUsersComponent]
})
export class CustomerUsersComponent {
  customerData: any;
  userId: number = 0;

  constructor(private customerService: CustomerService,
    private route: ActivatedRoute,
  ) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.userId = params['id']; // Access the 'id' parameter from the URL
     
    });

    this.customerData = this.customerService.getUserByOriginalId(this.userId).subscribe(
      (data: any) => {
        this.customerData = data;
        console.log(this.customerData);
      },
      (error: string) => {
        console.error('Error fetching customer data:', error);
      }
    );

  }
}
